import { render, staticRenderFns } from "./share-project.vue?vue&type=template&id=5e2ab0f4"
import script from "./share-project.vue?vue&type=script&lang=js"
export * from "./share-project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports